module.exports = __webpack_public_path__ + "static/img/jingliangLogo.7590a62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/jingliangLogo.png
// module id = c69/
// module chunks = 63